import { Session } from '@ally/federated-types'
import { useEffect } from 'react'
import { useHostServices } from '../../HostServices'

type Cif = number | string

interface SessionData {
  cif: Cif
  token: string
}

interface SessionService {
  setCif: (cif: Cif) => void
  setToken: (token: string) => void
  getData: () => Promise<SessionData>
}

export const SessionServiceFactory = (): SessionService => {
  let cif: Cif | null = null
  let token: string | null = null
  let resolve: ((value: SessionData) => void) | null = null

  const maybeResolve = (): void => {
    if (cif && token && resolve) {
      resolve({ cif, token })
      resolve = null
    }
  }

  return {
    setCif: (_cif): void => {
      cif = _cif

      maybeResolve()
    },
    setToken: (_token): void => {
      token = _token

      maybeResolve()
    },
    getData: async (): Promise<SessionData> => {
      if (!cif || !token) {
        return new Promise(_resolve => (resolve = _resolve))
      }

      return { cif, token }
    },
  }
}

export const SessionService = SessionServiceFactory()

export const getToken = (session: Session): string | null =>
  session.data?.access_token || null

export const useSessionService = (instance: SessionService): void => {
  const { session } = useHostServices()
  const cif = session.data?.cif
  const token = getToken(session)

  useEffect(() => {
    if (cif) {
      instance.setCif(cif)
    }
  }, [cif])

  useEffect(() => {
    if (token) {
      instance.setToken(token)
    }
  }, [token])
}
